import { useQuery } from '@tanstack/react-query';

import { complianceApi } from '~/shared/services/api';

export const GET_EMPLOYEE_ROLE_QUERY_KEY = 'getEmployeeRole';

export type GetEmployeeRoleAPIResponse = {
  id?: string;
  role?: string;
  zone?: string;
  meHierarchy?: string[];
  zones: string[];
  hierarchies: string[];
};

async function getEmployeeRole(
  employeeId: string
): Promise<GetEmployeeRoleAPIResponse> {
  const response = await complianceApi.get<GetEmployeeRoleAPIResponse>(
    `employees/${employeeId}/roles`
  );
  return response.data;
}

export function useGetEmployeeRole(employeeId: string) {
  return useQuery({
    queryKey: [GET_EMPLOYEE_ROLE_QUERY_KEY, employeeId],
    queryFn: async () => {
      if (!employeeId) return null;
      const response = await getEmployeeRole(employeeId);
      return response;
    },
  });
}
